export default {
  items: [
    {
      _name: 'CSidebarNav',
      _children: [
        {
          _name: 'CSidebarNavItem',
          name: 'Trang chủ',
          icon: 'cil-speedometer',
          to: '/dashboard.html'
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Quản lý nhóm Cụm thu phát thanh',
          icon: 'cil-bullhorn',
          to: '/audio-station-management/managed-audio-station.html'
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Quản lý nhóm Bảng điện tử',
          icon: 'cil-airplay',
          to: '/screen-station-management/managed-screen-station.html'
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý thiết bị',
          icon: 'cil-devices',
          items: [
            {
              name: 'Thiết bị Phát thanh',
              to: '/devices-management/audio-devices.html',
            },
            {
              name: 'Thiết bị Bảng điện tử',
              to: '/devices-management/screen-devices.html',
            }
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Biên tập Phát thanh',
          icon: 'cil-audio',
          items: [
            {
              name: 'Biên tập Bản tin phát thanh',
              to: '/audio-editor/upload-audio.html',
            },
            {
              name: 'Chuyển đổi văn bản sang giọng đọc',
              to: '/audio-editor/text-to-speech.html',
            },
            {
              name: 'Ghép tệp tin âm thanh',
              to: '/audio-editor/merge-file.html',
            },
            {
              name: 'Ghi âm tệp tin âm thanh',
              to: '/audio-editor/record-file.html',
            },
            // {
            //   name: 'Cắt file âm thanh',
            //   to: '/audio-editor/cut-file.html',
            // },
            // {
            //   name: 'Bản tin được gửi từ TW',
            //   to: '/audio-editor/file-from-central.html',
            // },
            {
              name: 'Gửi tin tới nhóm Cụm thu phát thanh',
              to: '/audio-editor/send-to-station.html',
            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Biên tập Bảng tin điện tử',
          icon: 'cil-file',
          items: [
            {
              name: 'Biên tập nội dung Bảng điện tử',
              to: '/screen-editor/upload-screen.html',
            },
            {
              name: 'Biên tập danh sách phát Bảng điện tử',
              to: '/screen-editor/play-list.html',
            },
            // {
            //   name: 'Nội dung phát được gửi từ TW',
            //   to: '/screen-editor/file-from-central.html',
            // },
            {
              name: 'Gửi nội dung phát tới Nhóm Nảng tin điện tử',
              to: '/screen-editor/send-to-station.html',
            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý Phát thanh',
          icon: 'cil-book',
          items: [
            {
              name: 'Bản tin Phát thanh đã biên tập',
              to: '/files-device-management/managed-files.html',

            },
            {
              name: 'Bản tin Phát thanh đã phát',
              to: '/files-device-management/managed-files-broadcast.html',

            },
            {
              name: 'Bản tin Phát thanh đang phát',
              to: '/files-device-management/managed-files-playing.html',
            },
            {
              name: 'Nhật ký Phát thanh',
              to: '/files-device-management/managed-files-history.html',

            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý nội dung Bảng điện tử',
          icon: 'cil-book',
          items: [
            {
              name: 'Nội dung Bảng điện tử đã biên tập',
              to: '/files-screen-management/managed-files.html',

            },
            {
              name: 'Nội dung Bảng điện tử đã phát',
              to: '/files-screen-management/managed-files-broadcast.html',

            },
            {
              name: 'Nội dung Bảng điện tử đang phát',
              to: '/files-screen-management/managed-files-playing.html',
            },
            {
              name: 'Nhật ký phát Bảng điện tử',
              to: '/files-screen-management/managed-files-history.html',

            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Báo cáo thống kê',
          icon: 'cil-bar-chart',
          items: [
            // {
            //   name: 'Nhóm truyền thanh',
            //   to: '/report-management/audio-stations.html',
            // },
            {
              name: 'Thiết bị Phát thanh',
              to: '/report-management/audio-devices.html',
            },
            {
              name: 'Thiết bị Bảng điện tử',
              to: '/report-management/screen-devices.html',
            },
            {
              name: 'Bản tin Phát thanh đã phát',
              to: '/report-management/audio-file-broadcast.html',
            },
            {
              name: 'Nội dung Bảng điện tử đã phát',
              to: '/report-management/screen-file-broadcast.html',
            },
            // {
            //   name: 'Báo cáo tài khoản',
            //   to: '/report-management/users.html',
            // },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản trị',
          icon: 'cil-settings',
          items: [
            {
              name: 'Quản lý cấu hình API',
              to: '/administrator/contractor-information.html',
            },
            {
              name: 'Quản lý lĩnh vực',
              to: '/administrator/file-type.html',
            },
            // {
            //   name: 'Quản lý danh mục địa phương',
            //   to: '/administrator/location.html',
            // },
            {
              name: 'Nhật ký hoạt động',
              to: '/administrator/user-activity-log.html',
            },
          ]
        },
        // {
        //   _name: 'CSidebarNavItem',
        //   name: 'Phản ánh người dân',
        //   icon: 'cil-voice-over-record',
        //   to: '/residents-feedback-management/managed-residents-feedback.html'
        // },
        {
          _name: 'CSidebarNavItem',
          name: 'Quản lý tài liệu',
          icon: 'cil-book',
          to: '/document-management/managed-document.html'
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Hướng dẫn sử dụng',
          icon: 'cil-hd',
          to: '#'
        },
      ]
    },
  ]
}
